import { createFrontendModule } from '@backstage/frontend-plugin-api';
import catalogPlugin from '@backstage/plugin-catalog/alpha';

/*
 * `page:catalog` renders `CatalogTable`, and the table body is not an extension
 * input — the only way to reach the redesign's scorecard grid is to replace the
 * page's loader. `getExtension(...).override({ params })` keeps the stock path,
 * title, icon and (critically) the catalog `rootRouteRef`, which a same-id
 * `PageBlueprint.make` would drop and break every `useRouteRef` link into /catalog.
 */
const catalogIndexPage = catalogPlugin.getExtension('page:catalog').override({
  params: {
    loader: () =>
      import('./CatalogIndexPage').then(m => <m.CatalogIndexPage />),
  },
});

export const catalogIndexModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [catalogIndexPage],
});
